import { render } from "./Capacitors.vue?vue&type=template&id=f05f69d2&scoped=true"
import script from "./Capacitors.vue?vue&type=script&lang=ts"
export * from "./Capacitors.vue?vue&type=script&lang=ts"

import "./Capacitors.vue?vue&type=style&index=0&id=f05f69d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f05f69d2"

export default script